import useSWR from 'swr'
import { $fetch } from 'ohmyfetch'

interface MintlistMerkleResponse {
  valid: boolean
  address: string
  proof: string[]
}

const fetchMerkle = (address: string) =>
  $fetch<MintlistMerkleResponse>(`/api/mintlist/merkle/${address}`)

function useMerkleProofData(address: string | undefined) {
  const merkleProofResponse = useSWR(
    address ? [address, 'mintlist-merkle'] : undefined,
    fetchMerkle,
  )

  return merkleProofResponse
}

export { useMerkleProofData }
